import React, { Component } from 'react';
import axios from 'axios';
//import { MDBContainer, MDBIframe } from "mdbreact";
import {
    MDBInput, MDBDatePicker, MDBSelect, toast, ToastContainer, MDBBtnFixedItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge,
    MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from 'mdbreact';
import AsyncSelect from 'react-select/async';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';

class PersonalInfo extends Component {
    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));

        this.state = {
            firstNames: "",
            surname: "",
            title: "",
            preferredName: "",
            initials: "",
            idNumber: "",
            telephoneHome: "",
            smsQueryCell: "",
            hAddressLine1: "",
            hAddressLine2: "",
            hAddressLine3: "",
            dAddressLine1: "",
            dAddressLine2: "",
            dAddressLine3: "",
            dateOfBirth: "",
            hPostalCode: "",
            dPostalCode: "",
            emailAddress: "",
            provinceId: 0,
            townId: 0,
            provinces: [],
            towns: [],
            modalOpen: false,
            btnDisabled: false,
            facebookName: "",
            instagramHandle: "",
            genders: [],
            gender: 0,
            doSelection: false,
            msg: "",
            selectedTown: '',
            selectedProvince: '',
            townModalOpen: false,
            townBtnHidden: false,
            share: false,
            hasBankPassword: false,
            passwordErrorHidden: true,
            passwordError: '',
            bankModalOpen: false,
            passwordDivHidden: true,
            confirmPassword: '',
            newPassword: '',
            addPasswordModalOpen: false,
            btnCreatePasswordDisabled: true,
            passwordCreateMsg: '',
            passwordMsgColor: '',
            btnText: 'Ok',
            btnForgotPWord: false,
            forgotPWordModalOpen: false,
            forgotPWordResultMsg: '',
            journeys:[]
        };
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleTownSelectChange = this.handleTownSelectChange.bind(this);
        this.handleGenderChange = this.handleGenderChange.bind(this);
        this.disableButton = this.disableButton.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleTown = this.toggleTown.bind(this);
        this.toggleBankPWord = this.toggleBankPWord.bind(this);
        this.forgotPassword = this.forgotPassword.bind(this);
        this.checkBoxchangeHandler = this.checkBoxchangeHandler.bind(this);
        this.createBankingPassword = this.createBankingPassword.bind(this);
        this.checkPasswords = this.checkPasswords.bind(this);
        this.handleJourneySelectChange = this.handleJourneySelectChange.bind(this);
    }

    async createBankingPassword() {
        var dl = new DataLayer();
        let result = await dl.Post('/demonstrator/createpassword', this.state.passwordCreate, false);
        //let token = await dl.GetToken();
        if (!result.errorOccurred) {
            this.setState({ addPasswordModalOpen: false, hasBankPassword: true })
            toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp;Banking Info Password Created Successfully. </span>, {
                closeButton: false
            });
        } else {
            alert('An error occurred');
        }
    }

    async forgotPassword() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/demonstrator/forgotPassword');
        if (!result.errorOccurred) {
            this.setState({ bankModalOpen: false, forgotPWordModalOpen: true, forgotPWordResultMsg:'Your Password will be re-set and we will send you your new password via sms to your registered mobile number.'})

        } else {
            this.setState({ bankModalOpen: false, forgotPWordModalOpen: true, forgotPWordResultMsg: 'An Error Ocurred Re-setting your password. Please Try Again.' })
        }
        this.props.loaderOff();
    }

    async toggleBankPWord(action) {
        if (action.toUpperCase() != 'CHANGE') {
            var dl = new DataLayer();
            let result = await dl.Post('/demonstrator/verifyPassword', this.state.bankInfoPassword, false);
            //let token = await dl.GetToken();
            if (!result.errorOccurred) {
                this.setState({
                    passwordDivHidden: false,
                    passwordErrorHidden: true,
                    addPasswordModalOpen: false,
                    passwordCreateMsg: '',
                    btnText: 'Change',
                    btnForgotPWord: true
                });

            } else {
                this.setState({
                    passwordError: result.errorMessage,
                    passwordErrorHidden: false,
                    addPasswordModalOpen: false
                });
            }

        } else {
            var dl = new DataLayer();
            let result = await dl.Post('/demonstrator/changeBankPassword', this.state.newPassword, false);
            if (!result.errorOccurred) {
                this.setState({ btnForgotPWord: false, btnText: 'Ok', bankModalOpen: false, passwordDivHidden: true, passwordErrorHidden: true})
                toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp;Banking Info Password Changed Successfully. </span>, {
                    closeButton: false
                });
            } else {
                alert("An Error Ocurred updating password.")
            }
        }


        

    }

    checkBoxchangeHandler(value) {
        
        if (value == "false") {
            //this.props.showHideNode('bInfo', false);
            this.setState({
                share: true
            })
        } else {
            //this.props.showHideNode('bInfo', true);
            this.setState({
                share: false
            })
        }

        //alert(this.state.acceptedTerms);
    };

    onSuburbChange = selSuburb => {
        console.log("Selected Suburb.................", selSuburb)
        var str = selSuburb.value;
        var res = str.split("(");
        var provPart = res[res.length - 1];
        provPart = provPart.split("-");//[0].trim().toUpperCase();
        var postCode = '';
        if (provPart.length == 3) {
            postCode = provPart[2].trim();
        } else {
            postCode = provPart[1].trim();
        }
        
        postCode = postCode.substring(0, postCode.length - 1);
        var provincePart = "";

        if (provPart.length > 1) {
            var count = provPart.length - 1;
            for (var i = 0; i < count; i++) {
                provincePart += provPart[i].toUpperCase();
            }
        } else {
            provincePart = provPart[0].trim().toUpperCase();
        }
        provincePart = provincePart.replace(/ /g, '');
        provincePart = provincePart.replace(/-/g, '');
        this.setState({
            selectedTown: selSuburb.value,
            townModalOpen: !this.state.townModalOpen,
            dAddressLine3: selSuburb.value,
            dPostalCode: postCode
        })

    }

    loadSuburbs = async (inputText, callback) => {
        let province = this.state.selectedProvince.toUpperCase();
        province = province.replace(/ /g, '');
        const response = await axios.get(`https://api.siteway.co.za/fastway/woo/v1/find-suburb-province-all/?query=${inputText}`);
        const json = response.data;
        console.log('JSON****************************', json)
        let suburbs = [];
        json.forEach((item) => {
            var str = item.value;
            var res = str.split("(");
            var provPart = res[res.length - 1];
            provPart = provPart.split("-");//[0].trim().toUpperCase();
            var provincePart = "";

            if (provPart.length > 1) {
                var count = provPart.length - 1;
                for (var i = 0; i < count; i++) {
                    provincePart += provPart[i].toUpperCase();
                }
            } else {
                provincePart = provPart[0].trim().toUpperCase();
            }
            provincePart = provincePart.replace(/ /g, '');
            provincePart = provincePart.replace(/-/g, '');
            if (provincePart == province) {
                suburbs.push(item);
            }
        });
        callback(suburbs.map(item => ({ label: item.text, value: item.value })));
    }

    toggle() {
        this.setState({
            modalOpen: !this.state.modalOpen,
            btnDisabled: false
        });

    }

    toggleTown() {
        this.setState({
            townModalOpen: !this.state.townModalOpen
        });
    }

    async disableButton() {
        this.setState({ btnDisabled: true });
        this.submitHandler();
    }

    async submitHandler() {//submitHandler = event => {
        //event.preventDefault();
        this.props.loaderOn();
        let d = new Date();
        let stateDate = new Date(this.state.dateOfBirth);
        let currDate = d.getFullYear() + "" + d.getMonth() + "" + d.getDay()
        let selectedDate = stateDate.getFullYear() + "" + stateDate.getMonth() + "" + stateDate.getDay()

        //this.setState({ dateOfBirth: dob });

        if (currDate == selectedDate) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please enter a valid Date of Birth.</span>, {
                closeButton: false
            });
            this.setState({ btnDisabled: false })
        } else if (this.state.townId == 0) {
            toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;Please select a valid town.</span>, {
                closeButton: false
            });
            this.setState({ btnDisabled: false })
        } else {

            let y = stateDate.getFullYear()
            let m = stateDate.getMonth() + 1;
            let dd = stateDate.getDate()

            var dob = y + "-" + m + "-" + dd;
            let requestObject = this.state;
            requestObject.dateOfBirth = dob;
            //event.target.className += " was-validated";
            var dl = new DataLayer();
            let result = await dl.Post('/demonstrator/UpdatePersonalInfo', requestObject);
            if (result.errorOccurred) {
                toast.error(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="exclamation-circle" />&nbsp;&nbsp;{result.errorMessage}</span>, {
                    closeButton: false
                });
                this.setState({ btnDisabled: false })
            } else {
                if (this.TMAUser.data.countryId == 6) {
                    this.props.showHideNode('bInfo', !this.state.share);
                }
                this.setState({
                    modalOpen: !this.state.modalOpen,
                    msg: result.otherInfo
                });

            }
        }
        this.props.loaderOff();
    };

    handleGenderChange(selected) {
        this.setState({
            gender: selected[0]
        });
    }

    handleJourneySelectChange(selected) {
        this.setState({
            sfJourneyId: selected[0]
        });
    }

    handleTownSelectChange(selected) {
        if (this.state.doSelection) {
            this.setState({
                townId: selected[0]
            });
        }
    }

    async handleSelectChange(selected) {
        if (this.state.doSelection) {
            this.props.loaderOn();
            var dl = new DataLayer();
            let result = await dl.Get('/common/gettowns?provinceId=' + selected, 200);
            let selProvince = ''
            this.state.provinces.forEach(x => {
                if (x.value == selected) {
                    selProvince = x.text.trim();
                }
            })
            this.setState({
                provinceId: selected[0],
                townId: result.data[0].value,
                towns: result.data,
                selectedProvince: selProvince,
                selectedTown: selected == 10 ? 'Outside South Africa' : '',
                townBtnHidden: selected == 10 ? true : false
            });

        } else {
            this.setState({ doSelection: true });
        }
        this.props.loaderOff();
    }

    checkPasswords(passwordCreate, passwordCreateConfirm) {
        if (passwordCreateConfirm === passwordCreate) {


            this.setState({ btnCreatePasswordDisabled: false })
            let password = passwordCreate

            var minRequirement = new RegExp(/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*\s).*$/);
            if (minRequirement.test(password)) {

                let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})')
                let mediumPassword = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))')

                if (strongPassword.test(password)) {
                    this.setState({ passwordCreateMsg: 'Password Strength: Strong', passwordMsgColor: 'green' });
                } else if (mediumPassword.test(password)) {
                    this.setState({ passwordCreateMsg: 'Password Strength: Medium', passwordMsgColor: 'blue' });
                } else {
                    this.setState({ passwordCreateMsg: 'Password Strength: Weak', passwordMsgColor: 'red' });
                }
            } else {
                this.setState({ btnCreatePasswordDisabled: true, passwordCreateMsg: 'Password does not meet requirements.', passwordMsgColor: 'red' });
            }
        } else {
            this.setState({ btnCreatePasswordDisabled: true, passwordCreateMsg: 'Passwords do not match.', passwordMsgColor: 'red' });
        }
    }

    blurHandler = event => {
        //alert(event.target.name)
        if (event.target.name == "newPassword" || event.target.name == "confirmPassword") {
            this.checkPasswords(this.state.newPassword, this.state.confirmPassword)
        } else {
            this.checkPasswords(this.state.passwordCreateConfirm, this.state.passwordCreate)
        }
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    async componentWillMount() {
        var testererere = this.TMAUser.countryId;
        var dl = new DataLayer();
        let provResult = await dl.Get('/common/getProvincesAndTowns', 200);
        let result = await dl.Get('/demonstrator/GetPersonalInfo', 200);
        let journeys = await dl.Get('/common/getJourneys', 200);
        let genList = provResult.data.genderList;
        genList.map((item) => {
            if (result.data.gender == (item.value * 1)) {
                item.checked = true;
            }
        })

        let journeyList = journeys.data
        let selJourney = '';
        journeyList.map((jitem) => {
            if (result.data.sfJourneyId == (jitem.value * 1)) {
                jitem.checked = true;
                //selProv = pitem.text
            } else {
                jitem.checked = false;
            }
        });

        let provList = provResult.data.provinceList
        let selProv = '';
        provList.map((pitem) => {
            if (result.data.provinceId == (pitem.value * 1)) {
                pitem.checked = true;
                selProv = pitem.text
            } else {
                pitem.checked = false;
            }
        });

        let townList = provResult.data.townList
        let selTown = '';
        townList.map((titem) => {
            if (result.data.townId == (titem.value * 1)) {
                titem.checked = true;
                selTown = titem.text
            } else {
                titem.checked = false
            }
        });

        this.setState({
            provinces: provList,
            towns: townList,
            genders: provResult.data.genderList,
            provinceId: result.data.provinceId,
            townId: result.data.townId,
            dateOfBirth: result.data.dateOfBirth,
            firstNames: result.data.firstNames,
            surname: result.data.surname,
            initials: result.data.initials,
            title: result.data.title,
            preferredName: result.data.preferredName,
            idNumber: result.data.idNumber,
            telephoneHome: result.data.telephoneHome,
            smsQueryCell: result.data.smsQueryCell,
            hAddressLine1: result.data.hAddressLine1,
            hAddressLine2: result.data.hAddressLine2,
            hAddressLine3: result.data.hAddressLine3,
            hPostalCode: result.data.hPostalCode,
            dAddressLine1: result.data.dAddressLine1,
            dAddressLine2: result.data.dAddressLine2,
            dAddressLine3: result.data.dAddressLine3,
            dPostalCode: result.data.dPostalCode,
            facebookName: result.data.facebookName,
            instagramHandle: result.data.instagramHandle,
            gender: result.data.gender,
            emailAddress: result.data.emailAddress,
            selectedTown: selTown,
            selectedProvince: selProv,
            townBtnHidden: result.data.provinceId == 10 ? true : false,
            share: result.data.share,
            hasBankPassword: result.data.hasBankPassword,
            journeys: journeyList
        })
        //this.props.loaderOff();
    };

    render() {
        return (
            <div>
                <Header headerText='Update Info'
                    hideSearch='true'
                />
                <form
                    className="needs-validation"
                    onSubmit={this.submitHandler}

                >
                    <MDBCard>
                        <MDBCardBody>
                            <MDBRow>
                                <MDBCol>
                                    <div style={{ fontWeight: "bold", textDecoration: "underline" }}>Personal Info</div>
                                </MDBCol>
                            </MDBRow>
                            
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBSelect label="Select Journey"
                                        options={this.state.journeys}
                                        selected="Journey"
                                        getValue={this.handleJourneySelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.title}
                                        name="title"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtTitle"
                                        label="Title"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBSelect label="Select Gender"
                                        options={this.state.genders}
                                        selected="Gender"
                                        getValue={this.handleTownSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>

                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.firstNames}
                                        name="firstNames"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="materialFormRegisterNameEx"
                                        label="First name"
                                        required
                                        disabled="true"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.surname}
                                        name="surname"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="materialFormRegisterEmailEx2"
                                        label="Surname"
                                        required
                                        disabled="true"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.preferredName}
                                        name="preferredName"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtPreferredName"
                                        label="Preferred Name"
                                        required
                                        disabled="true"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.initials}
                                        name="initials"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtInitials"
                                        label="Initials"
                                        required
                                        disabled="true"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.idNumber}
                                        name="idNumber"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="txtIDNumber"
                                        label="ID Number"
                                        required
                                        disabled="true"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.emailAddress}
                                        name="emailAddress"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="emailAddress"
                                        label="Email"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>

                                <MDBCol md="6">
                                    <div class="block">

                                        <MDBDatePicker
                                            invalidLabel=""
                                            invalidDateMessage="Please select a date"
                                            style={{ paddingTop: "15px" }}
                                            emptyLabel=""
                                            value={this.state.dateOfBirth}
                                            label="Date Of Birth"
                                            id="dateOfBirth"
                                            getValue={(e) => this.setState({ dateOfBirth: e })} />

                                    </div>

                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.telephoneHome}
                                        name="telephoneHome"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="telephoneHome"
                                        label="Tel Home"
                                        
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.smsQueryCell}
                                        name="smsQueryCell"
                                        onChange={this.changeHandler}
                                        type="number"
                                        id="smsQueryCell"
                                        label="Tel Mobile"
                                        required
                                        disabled="true"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.facebookName}
                                        name="facebookName"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="facebookName"
                                        label="Facebook Name"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.instagramHandle}
                                        name="instagramHandle"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="instagramHandle"
                                        label="Instagram Handle"
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol>
                                    {this.state.share ? (
                                        <MDBInput getValue={this.checkBoxchangeHandler} value={this.state.share} label="I consent to the publishing of my profile on an online sales platform, and for Umagazini Oluhle (Pty)Ltd to also continue to process my name, contact details, address and picture in order to give interested end customers the opportunity to contact me via the channels provided (e-mail, telephone or otherwise). Umagazini Oluhle (Pty)Ltd may also use my data in e-mails that may be automatically sent to the end customer for advertising purposes and in which Umagazini Oluhle (Pty)Ltd may name me as the contact person. Umagazini Oluhle (Pty)Ltd processes this data on the basis of our overriding legitimate interest in supporting you in the sale of our products. I acknowledge that I am responsible for ensuring all my information is true and correct and I may amend or delete my information." checked type="checkbox" id="checkbox2" />
                                    ) : (
                                            <MDBInput getValue={this.checkBoxchangeHandler} value={this.state.share} label="I consent to the publishing of my profile on an online sales platform, and for Umagazini Oluhle (Pty)Ltd to also continue to process my name, contact details, address and picture in order to give interested end customers the opportunity to contact me via the channels provided (e-mail, telephone or otherwise). Umagazini Oluhle (Pty)Ltd may also use my data in e-mails that may be automatically sent to the end customer for advertising purposes and in which Umagazini Oluhle (Pty)Ltd may name me as the contact person. Umagazini Oluhle (Pty)Ltd processes this data on the basis of our overriding legitimate interest in supporting you in the sale of our products. I acknowledge that I am responsible for ensuring all my information is true and correct and I may amend or delete my information." type="checkbox" id="checkbox2" />
                                        )}

                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                    <br />
                    <MDBCard>
                        <MDBCardBody>
                            <MDBRow>
                                <MDBCol md="6">
                                    <div style={{ fontWeight: "bold", textDecoration: "underline" }}>Home Address Detail</div>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.hAddressLine1}
                                        name="hAddressLine1"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="hAddressLine1"
                                        label="Street Number & Street Name"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.hAddressLine2}
                                        name="hAddressLine2"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="hAddressLine2"
                                        label="Complex Name & Number"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.hAddressLine3}
                                        name="hAddressLine3"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="hAddressLine3"
                                        label="Town/Suburb"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.hPostalCode}
                                        name="hPostalCode"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="hPostalCode"
                                        label="Post Code"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                    <br />
                    <MDBCard>
                        <MDBCardBody>
                            <MDBRow>
                                <MDBCol md="6">
                                    <div style={{ fontWeight: "bold", textDecoration: "underline" }}>Delivery Address Detail</div>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBSelect label="Select Province"
                                        options={this.state.provinces}
                                        selected="Province"
                                        getValue={this.handleSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <span >Town: {this.state.selectedTown}&nbsp;
                                        <MDBBtn hidden={this.state.townBtnHidden} tag="a" size="sm" floating onClick={this.toggleTown}>
                                            <MDBIcon icon="edit" />
                                        </MDBBtn>
                                    </span>
                                    {/*<MDBSelect label="Select Town"
                                        options={this.state.towns}
                                        selected="Town"
                                        getValue={this.handleTownSelectChange}
                                        required
                                    />*/}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.dAddressLine1}
                                        name="dAddressLine1"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="dAddressLine1"
                                        label="Street Number & Street Name"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.dAddressLine2}
                                        name="dAddressLine2"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="dAddressLine2"
                                        label="Complex Name & Number"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.dAddressLine3}
                                        name="dAddressLine3"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="dAddressLine3"
                                        label={this.TMAUser.data.countryId == 6 ? "Town/Suburb - (Not Editable)" : "Town/Suburb"}
                                        required
                                        disabled={this.TMAUser.data.countryId == 6 ? true : false}
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.dPostalCode}
                                        name="dPostalCode"
                                        onChange={this.changeHandler}
                                        type="text"
                                        id="dPostalCode"
                                        label={this.TMAUser.data.countryId == 6 ? "Post Code - (Not Editable)" : "Post Code"}
                                        required
                                        disabled={this.TMAUser.data.countryId == 6 ? true : false}
                                    >

                                    </MDBInput>
                                </MDBCol>

                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                    <MDBBtn disabled={this.state.btnDisabled} color="success" type="submit" >
                        Submit Form
                    </MDBBtn>
                    <MDBBtn hidden={this.TMAUser.data.countryId == 6 ? false : true} disabled={this.state.btnDisabled} color="success" onClick={() => this.state.hasBankPassword ? this.setState({ bankModalOpen: true }) : this.setState({ addPasswordModalOpen: true })}>
                        Manage Banking Info Password
                    </MDBBtn>
                </form>

                <MDBModal isOpen={this.state.modalOpen} toggle={this.state.modalOpen} centered>
                    <MDBModalHeader>Success</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.msg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggle}>Ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.townModalOpen} toggle={this.state.townModalOpen} centered>
                    <MDBModalHeader>Search Town</MDBModalHeader>
                    <MDBModalBody>
                        <AsyncSelect
                            value={this.state.selectedTown}
                            onChange={this.onSuburbChange}
                            placeholder="Type to Search Town"
                            loadOptions={this.loadSuburbs}
                        />
                    </MDBModalBody>

                </MDBModal>

                <MDBModal isOpen={this.state.bankModalOpen} toggle={this.state.bankModalOpen} centered>
                    <MDBModalHeader>Change Banking Info Password</MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>
                            <MDBCol>
                                Please enter your current password to continue.
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <MDBInput
                                    name="bankInfoPassword"
                                    onChange={this.changeHandler}
                                    type="password"
                                    id="bankInfoPassword"
                                    label="Bank Info Password"
                                    required
                                >

                                </MDBInput>
                            </MDBCol>
                        </MDBRow>
                        <div hidden={this.state.passwordErrorHidden}>
                            <MDBRow>
                                <MDBCol>
                                    <span style={{ color: "red" }}>{this.state.passwordError}</span>
                                </MDBCol>
                            </MDBRow>
                        </div>
                        <div hidden={this.state.passwordDivHidden}>
                            <MDBRow>
                                <MDBCol>
                                    Please enter and confirm your new password.<br />
                                    <span style={{ fontSize: "10px", fontWeight: "bold" }}>(Password needs to contain at least one uppercase character, one lowercase character and a number, and needs to be at least eight characters long.)</span>
                            </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.newPassword}
                                        name="newPassword"
                                        onChange={this.changeHandler}
                                        onBlur={this.blurHandler}
                                        type="text"
                                        id="newPassword"
                                        label="New Password"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.confirmPassword}
                                        name="confirmPassword"
                                        onChange={this.changeHandler}
                                        onBlur={this.blurHandler}
                                        type="text"
                                        id="confirmPassword"
                                        label="Confirm Password"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <span style={{ color: this.state.passwordMsgColor }}>{this.state.passwordCreateMsg}</span>
                                </MDBCol>
                            </MDBRow>
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn hidden={this.state.btnForgotPWord} rounded color="secondary" onClick={this.forgotPassword}>Forgot My Password</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.toggleBankPWord(this.state.btnText)}>{this.state.btnText}</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ btnForgotPWord: false, btnText:'Ok', bankModalOpen: false, passwordDivHidden: true, passwordErrorHidden: true })}>Cancel</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.addPasswordModalOpen} toggle={this.state.addPasswordModalOpen} centered>
                    <MDBModalHeader>Create Banking Info Password</MDBModalHeader>
                    <MDBModalBody>


                        <MDBRow>
                            <MDBCol>
                                Please enter and confirm your new password.<br />
                                <span style={{ fontSize: "10px", fontWeight: "bold" }}>(Password needs to contain at least one uppercase character, one lowercase character and a number, and needs to be at least eight characters long.)</span>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBInput
                                    value={this.state.passwordCreate}
                                    name="passwordCreate"
                                    onChange={this.changeHandler}
                                    onBlur={this.blurHandler}
                                    type="password"
                                    id="passwordCreate"
                                    label="Password"
                                    required
                                >

                                </MDBInput>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBInput
                                    value={this.state.passwordCreateConfirm}
                                    name="passwordCreateConfirm"
                                    onChange={this.changeHandler}
                                    onBlur={this.blurHandler}
                                    type="password"
                                    id="passwordCreateConfirm"
                                    label="Confirm Password"
                                    required
                                >

                                </MDBInput>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol>
                                <span style={{ color: this.state.passwordMsgColor}}>{this.state.passwordCreateMsg}</span>
                            </MDBCol>
                        </MDBRow>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn disabled={this.state.btnCreatePasswordDisabled} rounded color="secondary" onClick={this.createBankingPassword}>Ok</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ addPasswordModalOpen: false })}>Cancel</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>


                <MDBModal isOpen={this.state.forgotPWordModalOpen} toggle={this.state.forgotPWordModalOpen} centered>
                    <MDBModalHeader>Forgot Password</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.forgotPWordResultMsg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.setState({ forgotPWordModalOpen: false })}>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />
            </div>
        );
    }
}


export default PersonalInfo;